import React from "react";
import { Grid } from "@material-ui/core";
import { useQuery } from '@apollo/react-hooks';
import TileDefault from "../../Tiles/Default/TileDefault";
import TileComparative from "../../Tiles/Comparative/TileComparative";
import { GET_IMPRESSIONS } from "../../../queries/indicators";
import { GET_PAGEVIEWS_INDICATORS } from "../../../queries/analyticsReport";
import PageError from '../../PageError';
import PageLoading from '../../PageLoading';
import { momentFormat } from "../../Utils/formatters";
import { moment } from "../../Utils/momentConfig";


const formatImp = (number) => number ? new Intl.NumberFormat().format(number) : 0;

export default function ImpressionsIndicator(props) {
  let cards = [];
  let cardAlone = [];
  var { publishers, siteId, isDashboard } = props;
  let { data: dataIndicatorsImpressions, loading:loadingIndicatorsImpressions, error:errorIndicatorsImpressions } = useQuery(GET_IMPRESSIONS, {
    variables: { publishers: publishers },
  });
  let { data: dataAnalyticsPageViewsIndicators, loading:loadingAnalyticsPageViewsIndicators, error:errorAnalyticsPageViewsIndicators } = useQuery(GET_PAGEVIEWS_INDICATORS, {
    variables: { siteId: siteId }
  });

  if(dataIndicatorsImpressions){
    const rowImpressions = dataIndicatorsImpressions.reportImpressionsByPublisher;
    cardAlone = [      {
      product: "Impressions",
      todayRaw: { value: rowImpressions.todayImpressions ? rowImpressions.todayImpressions: 0 },
      yesterdayRaw: { value: rowImpressions.yesterdayImpressions ? rowImpressions.yesterdayImpressions: 0 },
      today: { value: rowImpressions.todayImpressions ? formatImp(rowImpressions.todayImpressions): 0 },
      week : rowImpressions.sevenDaysByDaysImpressions ? rowImpressions.sevenDaysByDaysImpressions.map(row => ({ quantity: row.value ? row.value.toFixed(2) : "0", 
      dateSubscribed: moment(row.date).add(1, 'days').format(momentFormat) })): [],
      yesterday: { value: rowImpressions.yesterdayImpressions ? formatImp(rowImpressions.yesterdayImpressions): 0 },
      weekly: { value: rowImpressions.sevenDaysImpressions ? formatImp(rowImpressions.sevenDaysImpressions): 0 },
      monthly: { value: rowImpressions.monthImpressions ? formatImp(rowImpressions.monthImpressions): 0 },
      color: "primary",
      isAvg: false,
      isRaw: true
    }];
  }

  if(dataIndicatorsImpressions && dataAnalyticsPageViewsIndicators && !isDashboard === true){
    const rowPageViews = dataAnalyticsPageViewsIndicators.pageViewsIndicators;
    const rowImpressions = dataIndicatorsImpressions.reportImpressionsByPublisher;

    if(siteId !== "")
    cards = [
    {
      product: "Impressions",
      today: { value: rowImpressions.todayImpressions ? formatImp(rowImpressions.todayImpressions.toFixed(2)): 0 },
      todayRaw: { value: rowImpressions.todayImpressions ? rowImpressions.todayImpressions.toFixed(2) : 0 },
      yesterday: { value: rowImpressions.yesterdayImpressions ? formatImp(rowImpressions.yesterdayImpressions.toFixed(2)) : 0 },
      weekly: { value: rowImpressions.sevenDaysImpressions ? formatImp(rowImpressions.sevenDaysImpressions.toFixed(2)): 0 },
      monthly: { value: rowImpressions.monthImpressions ? formatImp(rowImpressions.monthImpressions.toFixed(2)): 0 },
      
      product2: "PageViews",
      today2: { value: rowPageViews.todayPageViews ? formatImp(rowPageViews.todayPageViews.toFixed(2)): 0 },
      today2Raw: { value: rowPageViews.todayPageViews ? rowPageViews.todayPageViews.toFixed(2) : 0 },
      yesterday2: { value: rowPageViews.yesterdayPageViews ? formatImp(rowPageViews.yesterdayPageViews.toFixed(2)) : 0 },
      weekly2: { value: rowPageViews.sevenDaysPageViews ? formatImp(rowPageViews.sevenDaysPageViews.toFixed(2)): 0 },
      monthly2: { value: rowPageViews.monthPageViews ? formatImp(rowPageViews.monthPageViews.toFixed(2)): 0 },
    }
  ];
  }
  
  return (
    <>
    {(loadingIndicatorsImpressions) ? <Grid item xs={12}><PageLoading /></Grid> : 
    (errorIndicatorsImpressions) ? <Grid item xs={12}><PageError /></Grid> :
      (
        <>
        {
        cardAlone.map(stat => (
          (<Grid item md={4} sm={6} xs={12} key={stat.product}>
            <TileDefault {...stat} />
          </Grid>)
        ))
        }
        </>
      )
    }
    {(loadingAnalyticsPageViewsIndicators) ? <Grid item xs={12}><PageLoading /></Grid> : 
    (errorAnalyticsPageViewsIndicators) ? <Grid item xs={12}><PageError /></Grid> :
      (
        <>
        {
        cards.map(stat => (
          (<Grid item md={4} sm={6} xs={12} key={stat.product}>
            <TileComparative {...stat} />
          </Grid>)
        ))
        }
        </>
      )
    }
    </>
  );
}